<template>
  <span>
    <v-card class="elevation-10">
      <infractions-header
        :infraction_notices="infractions"
        :amount="cards"
        :activeStatus="status"
        @activeStatusChanged="changeActiveStatus"
      />
    </v-card>
    <v-progress-linear
      v-if="isLoading && isAdmin"
      indeterminate
      color="teal darken-4"
    />

    <infraction-list
      :infractions="infractions"
      :totalPages="total_pages"
      :totalItems="cards.total"
      @changePage="changePage"
    />
  </span>
</template>

<script>
import InfractionService from "@/services/applications/InfractionService";
import InfractionsHeader from '@/components/tabs/header/InfractionsHeader';
import InfractionList from '@/components/tabs/list/InfractionList';

export default {
  name: 'Infraction',
  props: ['isAdmin'],
  components: {
    InfractionList,
    InfractionsHeader,
  },
  data() {
    return {
      status: '',
      page: 1,
      infractions: [],
      cards: { total:0 },
      total_filtered: 0,
      total_pages: 0,
      isLoading: false,
    };
  },
  mounted() {
    this.fetchInfraction();
  },
  methods: {
    changeActiveStatus(status) {
      this.status = status;
      this.fetchInfraction();
    },
    fetchInfraction() {
      this.isLoading = true;
      if (this.isAdmin) {
        this.fetchAdminInfraction();
      }
    },
    fetchAdminInfraction() {
      InfractionService
        .adminFetchInfraction({ status: this.status, page: this.page })
        .then(({ data }) => {
          this.infractions = data.infraction_notices;
          this.cards = data.cards;
          this.total_filtered = data.total_filtered;
          this.total_pages = data.total_pages;
          this.$emit('amount', this.cards.waiting_to_be_sent);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    changePage(page) {
      this.page = page;
      this.fetchAdminInfraction();
    }
  }
}
</script>
